import { Crown, ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0A0A0A]">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-10">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#D4AF37]/50 bg-[#D4AF37]/10">
                <Crown className="h-4 w-4 text-[#D4AF37]" strokeWidth={1.5} />
              </span>
              <span className="leading-tight">
                <span className="block font-serif text-lg font-semibold tracking-wide">KINGDOM</span>
                <span className="block text-[10px] font-medium uppercase tracking-[0.28em] text-zinc-400">
                  Partnership Blueprint&trade;
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-zinc-500">
              Don&rsquo;t chase the customer. Find the people who already have their attention.
              Serve them first. Build trust. Build partnerships. Measure the result.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-12 sm:grid-cols-3">
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-zinc-500">Engines</p>
              <ul className="mt-4 space-y-2.5 text-sm text-zinc-400">
                <li>Podcasts</li>
                <li>YouTube</li>
                <li>Facebook</li>
                <li>TikTok</li>
                <li>Instagram</li>
              </ul>
            </div>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-zinc-500">Platform</p>
              <ul className="mt-4 space-y-2.5 text-sm text-zinc-400">
                <li><a href="#method" data-testid="footer-link-method" className="transition-colors hover:text-[#D4AF37]">The Method</a></li>
                <li><a href="#score" data-testid="footer-link-score" className="transition-colors hover:text-[#D4AF37]">Opportunity Score</a></li>
                <li><a href="#results" data-testid="footer-link-results" className="transition-colors hover:text-[#D4AF37]">Attribution</a></li>
                <li><a href="#assistant" data-testid="footer-link-assistant" className="transition-colors hover:text-[#D4AF37]">AI Assistant</a></li>
              </ul>
            </div>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-zinc-500">Principle</p>
              <p className="mt-4 flex items-start gap-2 text-sm leading-relaxed text-zinc-400">
                <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-[#047857]" />
                We optimize for valuable relationships — never messages sent. AI-assisted,
                human-approved, platform-compliant.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-zinc-600 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; {new Date().getFullYear()} KINGDOM PARTNERSHIP BLUEPRINT&trade;. All rights reserved.</p>
          <p>Built for relationship builders, not spammers.</p>
        </div>
      </div>
    </footer>
  );
}
